<div class="defaultAside aside-open slide-box-show" id="processHolder">
    <a href="javascript:void(0)" class="closebtn" (click)="close()">&times;</a>

    <div class="page-header-banner">
        <h1>Help Question</h1>
    </div>

    <div class="p-4">

        <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="save()">
            <div class="mb-3">
                <label>Question</label>
                <input
                    type="text"
                    autocomplete="new-password"
                    class="form-control"
                    [ngClass]="{'is-invalid' : form.controls.question.invalid && form.controls.question.dirty}"
                    formControlName="question"
                    placeholder="Enter question">
                <div class="invalid-feedback">Enter a valid question</div>
            </div>

            <div class="mb-3">
                <label>Topic</label>
                <select
                    class="form-control"
                    [ngClass]="{'is-invalid' : form.controls.topic.invalid && form.controls.topic.dirty}"
                    formControlName="topic">
                    <option [ngValue]="topic.id" *ngFor="let topic of topics">{{topic.name}}</option>
                </select>
                <div class="invalid-feedback">Topic must be selected</div>
            </div>


            <div class="mb-3">
                <label>Answer</label>
                <editor formControlName="answer" [apiKey]="this.env.tinymceApiKey" [init]="tinyInit"></editor>

<!--                <textarea-->
<!--                    rows="8"-->
<!--                    type="text"-->
<!--                    autocomplete="new-password"-->
<!--                    class="form-control"-->
<!--                    [ngClass]="{'is-invalid' : form.controls.answer.invalid && form.controls.answer.dirty}"-->
<!--                    formControlName="answer"-->
<!--                    placeholder="Enter answer"></textarea>-->
                <div class="invalid-feedback">Answer must be entered</div>
            </div>

            <label>Would you like to link to a website page?</label>
            <select class="form-control" formControlName="linkToRoute">
                <option [ngValue]="0">No page link</option>
                <option [ngValue]="p.id" *ngFor="let p of pages">{{p.name}}</option>
            </select>

            <div class="mb-3" *ngIf="form.value.linkToRoute !== 0">
                <label>Page link button text</label>
                <input
                    type="text"
                    autocomplete="new-password"
                    class="form-control"
                    [ngClass]="{'is-invalid' : form.controls.linkToRouteText.invalid && form.controls.linkToRouteText.dirty}"
                    formControlName="linkToRouteText"
                    placeholder="Enter button text">
                <div class="invalid-feedback">Enter button text</div>
            </div>


            <div class="mt-2">
                <a (click)="toggleStatus()">
                    <i
                        class="toggle fa"
                        [ngClass]="{
                        'fa-toggle-on text-success': form.value.status,
                        'fa-toggle-off' : !form.value.status}"></i>
                    Make available?
                </a>
            </div>

            <div class="mt-4 text-end">
                <button
                    [disabled]="form.invalid"
                    class="btn btn-round btn-primary mt-4"
                    type="submit"
                    tabindex="3">
                    Submit
                </button>
            </div>

        </form>


    </div>
</div>
